import { NOT_YET_LOADED } from 'scenes/common/helpers/apiData';
import {
  RetrieveFunnelState,
  RetrieveFlowType,
  RetrieveStepType,
} from './types';

export const initialRetrieveQuoteState: RetrieveFunnelState = {
  flow: RetrieveFlowType.RetrieveQuoteDetails,
  step: RetrieveStepType.RetrieveQuote,
  apiResponses: {
    motorQuoteDetails: NOT_YET_LOADED,
    homeQuoteDetails: NOT_YET_LOADED,
    landlordQuoteDetails: NOT_YET_LOADED,
    config: NOT_YET_LOADED,
  },
};
